import CatSubGradeDropdown from '@/components/cat-sub-grade-drpdn/cat-sub-grade-drpdn';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'navigator-class-setting',
    components: {
        'material-icons': GoogleMaterialIcon,
        'cat-sub-grade-drpdn': CatSubGradeDropdown,
    },
})

export default class NavigatorClassSetting extends Vue {

    @Prop()
    private categorySubjectData: any;

    @Prop()
    private value: any;

    @Prop()
    private isReadOnly: any;

    private isWithGrades: any = false;

    private isWithFw: any = true;

    private updateValue: any;

    private dataStringValue: any = '';

    private content: any = {};

    private isExpand: boolean = false;

    private indexNumber: number = 5;

    private categoryList: any = [];

    private dataPropsValues: any = [];

    private navClassSettingss: any = {
        diagnosticApplicable: {
            name: 'Diagnostic applicable',
            parentKey: null,
            keyName: 'diagnostic_applicable',
            required: {},
            items: [],
            fieldType: 'b-form-checkbox',
            options: {
                switch: true,
            },
        },
        masteryApplicable: {
            name: 'Mastery applicable',
            parentKey: null,
            keyName: 'mastery_applicable',
            required: {},
            items: [],
            fieldType: 'b-form-checkbox',
            options: {
                switch: true,
            },
        },
        studentMathLevel: {
            name: 'Student math level',
            parentKey: null,
            keyName: 'student_math_level',
            required: {},
            items: [],
            fieldType: 'b-form-input',
            options: {

            },
        },
        classOrigin: {
            name: 'Student math level',
            parentKey: null,
            keyName: 'class_origin',
            required: {},
            items: [],
            fieldType: 'b-form-input',
            options: {

            },
        },
        courseId: {
            name: 'Student math level',
            parentKey: null,
            keyName: 'course_id',
            required: {},
            items: [],
            fieldType: 'b-form-input',
            options: {

            },
        },
        gradewiseCourse: {
            name: 'Student math level',
            parentKey: null,
            keyName: 'gradewise_course',
            required: {},
            items: [],
            fieldType: 'b-form-checkbox',
            options: {
                switch: true,
            },
        },
        courses: {
            name: 'Courses',
            parentKey: null,
            keyName: 'courses',
            required: {},
            items: [],
            fieldType: 'b-form-input',
            options: {

            },
        },
    };

    @Watch('categorySubjectData')
    private onWatchData(data: any) {
        if (data && data.length > 0) {
            this.fetchDisplayPropParent();
        }
    }
    // --------------------------------------------------------------------
    // Properties
    // ---------------------------------------------------------------------
    // Methods

    private created() {
        this.content = this.value;
        if (this.isReadOnly) {
            // this.fetchDisplayProp();
        }
    }

    private mounted() {
        if (this.categorySubjectData && this.categorySubjectData.length > 0) {
            this.fetchDisplayPropParent();
        }
    }

    private updateCatSub(value: any) {
        this.updateValue = value;
        this.onUpdate();
    }

    private onUpdate() {
        if (!this.isWithGrades && this.isWithFw) {
            if (this.updateValue && this.updateValue.frameworks && this.updateValue.frameworks.selectedItems) {
                this.$emit('input', {
                    [this.updateValue.frameworks.selectedItems]:
                        this.updateValue.frameworks.selectedItems,
                });
            }
        }
    }

    private async fetchDisplayPropParent() {
        // const valueData: any = { "CCSS.K12.MA": 80, "TNM.K12.MA": 75, "SC.HE.CS":60, "GDF.HE.BS":50 };
        const categoryList = this.categorySubjectData;
        const valueData: any = this.content;
        const dataValuesCalculate: any = [];
        for (const prop in valueData) {
            if (valueData.hasOwnProperty(prop)) {
                const propSplit = prop.split('.');
                const data: any = {
                    keyName: prop,
                    categoryId: propSplit[0],
                    otherValues: valueData[prop],
                    subjectId: prop,
                    framework: valueData[prop].framework,
                };
                dataValuesCalculate.push(data);
            }
        }
        for await (const [index, iterator] of dataValuesCalculate.entries()) {
            const selectedCategoryIndex = categoryList.findIndex((catItem: any) => {
                return catItem.code === iterator.categoryId;
            });
            if (selectedCategoryIndex !== -1) {
                const selectedSubjectIndex = categoryList[selectedCategoryIndex].subjectList.findIndex((item: any) => {
                    return item.id === iterator.subjectId;
                });
                const selectedSubject = categoryList[selectedCategoryIndex].subjectList[selectedSubjectIndex];
                iterator.subjectTitle = selectedSubject && selectedSubject.title ? selectedSubject.title : '';
            }
        }
        this.dataPropsValues = dataValuesCalculate;
    }

    private getSubjectList(categoryId: string) {
        return taxonomyAPI.fetchSubjects(categoryId).then((subjectList: any) => {
            return subjectList;
        });
    }

    private makeStringToShow() {
        const dataValue = this.dataPropsValues;
        let emptyString = '';
        for (const iterator of dataValue) {
            emptyString += `${iterator.categoryId} - ${iterator.subjectTitle} | ${iterator.framework} ; `;
        }
        this.dataStringValue = emptyString;
    }

    private showMore() {
        this.indexNumber = this.indexNumber + 5;
        this.$emit('showMore');
    }

    private adjustHeight() {
        this.$emit('showMore');
    }
}
